<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/project/details/', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">Zum Projekt</a>
    </li>
  </ul>
</nav>

<main>
  <h2>Request  {{ projectId }}.0001.{{ requestId }}</h2>
  <p *ngIf="!loading1">
    <span class="label label-light-blue">Anfrage vom: {{ requests.requests_date | date:'dd.MM.yyyy'  }}</span>
    <span class="label label-light-blue">Angebotsabgabe bis: {{ requests.requests_submit | date:'dd.MM.yyyy' }}</span>
    <span class="label label-light-blue">Summe (netto): {{ requestTotal | currency: 'EUR':'code':'1.2-2':'de' }}</span>
    <span class="label {{ statusLabel }}">Status: {{ statusText }}
      <clr-dropdown [clrCloseMenuOnItemClick]="true">
        <button clrDropdownTrigger aria-label="Dropdown demo button">
            <cds-icon shape="angle" direction="down" size="'sm'"></cds-icon>
        </button>
        <clr-dropdown-menu *clrIfOpen>
            <label class="dropdown-header" aria-hidden="true">Status ändern</label>
            <div class="dropdown-divider" role="separator" aria-hidden="true"></div>
          <ng-container *ngFor="let item of statusButtons let i = index" >
            <div clrDropdownItem *ngIf="!item.locked"  (click)="changeRequestStatus(projectId, requestId, i)">
              {{ item.display }}
            </div>
          </ng-container>
        </clr-dropdown-menu>
      </clr-dropdown>
    </span>
  </p>

  <div class="spinner" *ngIf="loading1">Loading data</div>
  <div class="clr-row" *ngIf="!loading1">
    <div class="clr-col-lg-12 clr-col-md-12 clr-col-12">
      <div class="card">
        <div class="card-header">
          {{ requests.subject }}
        </div>
        <div *ngIf="!!positions" class="card-block">
          <div class="card-text">
            <clr-tabs>
              <clr-tab>
                <button clrTabLink>Übersicht</button>
                <clr-tab-content clrTabContentId="content1" *clrIfActive="true">
                  <br>
                  <div class="clr-row">
                    <div class="clr-col-5">
                      <div class="clr-row">
                        <div class="clr-col-6">
                          Anfrage an
                        </div>
                        <div class="clr-col-1">
                          <cds-icon shape="note" [routerLink]="['/contact/details', requests.requests_cid ]"></cds-icon>
                        </div>
                        <div class="clr-col-5">
                          {{ requests.requests_company }}<br />{{ requests.reqstreet }}<br />{{ requests.reqpostcode }} {{ requests.reqcity }}
                          <span *ngIf="requests.reqcountry !== 'Deutschland'">{{ requests.reqcountry}}</span>
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-6">
                          Ansprechpartner beim Lieferanten
                        </div>
                        <div class="clr-col-1">
                          <cds-icon shape="note" [routerLink]="['/person/details', requests.requests_person ]"></cds-icon>
                        </div>
                        <div class="clr-col-5">
                          {{ requests.requests_salutation }} {{ requests.requests_firstname }} {{ requests.requests_lastname }}
                        </div>
                      </div>
                      <div class="clr-row" *ngIf="requests.purchasing_id">
                        <div class="clr-col-6">
                          Angebotsnummer des Lieferanten
                        </div>
                        <div class="clr-col-1"></div>
                        <div class="clr-col-5">
                          {{ requests.purchasing_id }}
                        </div>
                      </div>
                    </div>
                    <div class="clr-col-7">
                      <div class="clr-row">
                        <div class="clr-col-2">
                          Kommentare
                        </div>
                        <div class="clr-col-10">
                          <app-comment-feature-card [projectId]=projectId [companyId]=requests.requests_cid [staffId]=requests.employee_phm [subId]=requestId [commentType]=1></app-comment-feature-card>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="btn-group btn-sm btn-primary">
                    <button class="btn"  [routerLink]="['/request/update', projectId, requestId]">Anfrage bearbeiten</button>
                    <button class="btn btn-danger" (click)="deleteRequest(projectId, requestId)">Anfrage löschen</button>
                  </div>

                  <clr-datagrid *ngIf="editPos < 2" [clrDgLoading]="loading2" [(clrDgSelected)]="selected" [clrDgRowSelection]="true">
                    <clr-dg-action-bar *ngIf="((editPos < 2) && (statusText === 'Entwurf'))">
                      <div class="btn-group">
                        <button type="button" class="btn btn-sm btn-danger-outline" (click)="onDelete()" ><cds-icon shape="minus-circle"></cds-icon> Positionen löschen</button>
                      </div>
                    </clr-dg-action-bar>
                    <clr-dg-column>Position</clr-dg-column>
                    <clr-dg-column [clrDgField]="'for_pdf'">PDF</clr-dg-column>
                    <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
                    <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
                    <clr-dg-column>Material</clr-dg-column>
                    <clr-dg-column>Kennzeichnung</clr-dg-column>
                    <clr-dg-column [clrDgField]="'specification'">Spezifikation</clr-dg-column>
                    <clr-dg-column>Bemerkungen</clr-dg-column>
                    <clr-dg-column class="center">Anzahl</clr-dg-column>
                    <clr-dg-column class="currency">Angebot</clr-dg-column>
                    <!--<clr-dg-column>Status</clr-dg-column>-->
                    <clr-dg-column *ngIf="editPos > 0"></clr-dg-column>
                    <clr-dg-placeholder>We couldn't find any Position for Request {{ projectId }}.0001.{{ requestId }}!</clr-dg-placeholder>
                    <clr-dg-row *clrDgItems="let position of positions; index as i" [clrDgItem]="position">
                      <clr-dg-cell>{{ position.position_label || position.position }}<span *ngIf="position.part > 0">.{{ position.part }}</span> </clr-dg-cell>
                      <clr-dg-cell>
                        <span *ngIf="position.for_pdf"><cds-icon shape="file" (click)="setVisibility(position.position, position.part, false)"></cds-icon></span>
                        <span *ngIf="!position.for_pdf"><cds-icon shape="eye-hide" (click)="setVisibility(position.position, position.part, true)"></cds-icon></span>
                      </clr-dg-cell>
                      <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing]">
                        <b>{{ position.name }}</b>
                        <clr-tooltip *ngIf="position.comment_phm">
                          <cds-icon clrTooltipTrigger role="img" shape="info-circle" size="24" aria-label="PHM comment tooltip"></cds-icon>
                          <clr-tooltip-content clrPosition="bottom-right" clrSize="md" *clrIfOpen>
                            <span>{{ position.comment_phm }}</span>
                          </clr-tooltip-content>
                        </clr-tooltip>
                        <span *ngIf="position.description"><br />{{ position.description }}</span>
                        <span *ngIf="position.taric && position.taric !== '0'"><br />(Zolltarifnummer: {{ position.taric }})</span>
                      </clr-dg-cell>
                      <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing]">{{ position.technical_drawing }}</clr-dg-cell>
                      <clr-dg-cell>
                        {{ position.material }}
                        <span class="small" *ngIf="position.heat_nr !== 'null'"><br /><br />{{ position.heat_nr }}</span>
                        <span class="small" *ngIf="position.controlling_nr !== 'null'"><br *ngIf="((!position.heat_nr) || (position.heat_nr === 'null') || (position.heat_nr === ''))" /><br />{{ position.controlling_nr }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell><span *ngIf="position.serial_nr !== 'null'">{{ position.serial_nr }}</span> </clr-dg-cell>
                      <clr-dg-cell>
                        <span *ngIf="position.specification">{{ position.specification }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell>
                        <span *ngIf="position.remarks"><b>Leistungsumfang:</b> {{ position.remarks }}<br *ngIf="position.side_agreements" /><br *ngIf="position.side_agreements" /></span>
                        <span *ngIf="position.side_agreements"><b>Nebenabreden (Lieferant):</b> {{ position.side_agreements }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell class="center"><span *ngIf="position.number_of_pieces > 0 ">{{ position.number_of_pieces }}</span></clr-dg-cell>
                      <clr-dg-cell class="right currency" *ngIf="((position.purchasing_price > 0) || (position.purchasing_price < 0))"><b>{{ position.purchasing_price | currency: 'EUR':'code':'1.2-2':'de' }}</b></clr-dg-cell>
                      <clr-dg-cell class="currency" *ngIf="position.purchasing_price == 0"> --- </clr-dg-cell>
                      <!--<clr-dg-cell class="right">{{ position.request_position_status }}</clr-dg-cell>-->
                      <clr-dg-cell *ngIf="editPos > 0" class="btn-group btn-primary btn-icon btn-sm" minlength="300px">
                        <button class="btn" (click)="updatePositionMode(i, position.position, position.part)">
                          <cds-icon shape="pencil"></cds-icon>
                        </button>
                      </clr-dg-cell>
                    </clr-dg-row>
                    <clr-dg-footer>
                      <clr-dg-pagination #pagination [clrDgPageSize]="50">
                        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Positionen pro Seite</clr-dg-page-size>
                        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
                        von {{positions.length}} Position(en)
                      </clr-dg-pagination>
                    </clr-dg-footer>
                  </clr-datagrid>

                  <app-request-edit-position [projectNumber]="projectId" [requestNumber]="requestId" [editPosition]="positionId" [editPart]="partId" *ngIf="editPos === 2"  (updatedPosition)="updateRequest($event)"></app-request-edit-position>

                  <br *ngIf="(editPos === 1)"  />

                  <clr-dropdown *ngIf="(editPos === 1)" [clrCloseMenuOnItemClick]="false">
                    <button clrDropdownTrigger class="dropdown-toggle btn btn-link" aria-label="Dropdown positions button">
                      Projektposition hinzufügen
                      <cds-icon shape="angle" direction="down" size="'sm'"></cds-icon>
                    </button>
                    <clr-dropdown-menu *clrIfOpen>
                      <div clrDropdownItem *ngFor="let components of foundPositions" (click)="addRow(components.position, components.positions_part, components.technical_drawing, components.name)">{{ components.position }}.{{ components.positions_part }}  {{ components.name }} ({{ components.technical_drawing }})</div>
                    </clr-dropdown-menu>
                  </clr-dropdown>

                  <br *ngIf="(editPos === 1)"  /><br />
                  <div class="btn-group btn-sm btn-primary">
                    <button *ngIf="editPos === 0" class="btn" (click)="basic = true; createRequest(positions)">PDF anzeigen</button>
                    <button *ngIf="editPos === 0" class="btn" (click)="editPos = 1;">Positionen bearbeiten</button>
                    <button *ngIf="editPos > 0" class="btn" (click)="editPos = 0;">Bearbeitung beenden</button>
                  </div>

                </clr-tab-content>
              </clr-tab>

              <clr-tab>
                <button clrTabLink>Dokumente</button>
                <clr-tab-content clrTabContentId="content2" *clrIfActive>
                  <app-request-details-documents [projectId]="projectId" [requestId]="requestId"></app-request-details-documents>
                </clr-tab-content>
              </clr-tab>
            </clr-tabs>
          </div>
        </div>
        <div class="card-footer">
          <small>Projektverantwortlich:  {{ staffFirstName }} {{ staffLastName }} ({{ requests.employee_phm }})</small>
        </div>
      </div>
    </div>
  </div>
</main>

<clr-modal [(clrModalOpen)]="basic" [clrModalSize]="'xl'">
  <h3 class="modal-title">ANFRAGE {{ projectId }}.0001.{{ requestId }}</h3>
  <div id="documentContainer" class="modal-body"></div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="basic = false">Zurück</button>
    <button type="button" class="btn btn-primary" (click)="downloadPdf(); basic = false">Download</button>
    <button type="button" class="btn btn-primary" (click)="archivePdf(); basic = false">Archivieren</button>
    <button type="button" class="btn btn-primary" (click)="printPdf(); basic = false">Drucken</button>
  </div>
</clr-modal>

<!--<pre class="datepicker-output">
{{ selected | json }}
</pre>-->
